import { useSitecoreContext } from '@sitecore-jss/sitecore-jss-nextjs';

import { ComponentProps, SitecoreContextValue } from 'src/lib/ComponentProps';

import { ResourceHeadings } from 'src/types/ResourceListItem';

import { isClinicalTopic } from 'src/utils/isTemplate';

import Accordion from 'src/components/basicContent/_Accordion/Accordion';

import BookIconSvg from 'public/icons/Book.svg';
import ChevronDownIconSvg from 'public/icons/ChevronDown.svg';

import ContentOverviewHeaderContainer from '../_contentOverviewHeaderContainer/ContentOverviewHeaderContainer';

import styles from './ContentOverviewResourceNavigation.module.css';

type ContentOverviewResourceNavigationProps = ComponentProps & {
	fields: {
		WildCardContentTemplateId: string;
		ResourceTitle: string;
		ResourceSubtitle: string;
		ResourceNavigationDescription: string;
		ResourceHeadings: ResourceHeadings[];
	};
};

export default function ContentOverviewResourceNavigation(props: ContentOverviewResourceNavigationProps): JSX.Element {
	const { sitecoreContext } = useSitecoreContext<SitecoreContextValue>();

	if (
		isClinicalTopic(props.fields?.WildCardContentTemplateId) ||
		!props.fields?.ResourceHeadings ||
		props.fields.ResourceHeadings.length < 1
	) {
		return <></>;
	}

	const title = sitecoreContext.dictionary?.resourceNavigationTitle
		? sitecoreContext.dictionary.resourceNavigationTitle
		: props.fields.ResourceTitle;

	const subHeader = props.fields.ResourceNavigationDescription ? props.fields.ResourceNavigationDescription : props.fields.ResourceSubtitle;

	return (
		<section className="maxWidth pad" id="resource-navigation">
			<ContentOverviewHeaderContainer header={title} subHeader={subHeader} />

			{props.fields.ResourceHeadings.map((item, index) => {
				return (
					<Accordion key={index} sectionClass={styles.accordion} headerClass={styles.accordionHeader} bodyClass={styles.accordionBody}>
						<>
							{item.pageTitle}
							<span>
								<ChevronDownIconSvg className={styles.chevron} />
							</span>
						</>

						<>
							<p className={styles.paragraph}>{item?.headings?.find((h) => h.strapline)?.strapline ?? ''}</p>

							<ul className={styles.list}>
								{item.headings.map((item, index) => (
									<li key={index} className={styles.item}>
										<span className={styles.icon}>
											<BookIconSvg />
										</span>

										<div className={styles.text}>
											<a href={item.url} className={styles.link}>
												{item.navigationLinkText ? item.navigationLinkText : item.text}
											</a>
										</div>
									</li>
								))}
							</ul>
						</>
					</Accordion>
				);
			})}
		</section>
	);
}
